import { render, staticRenderFns } from "./StockClosingPrintDetail_Company.vue?vue&type=template&id=b9cd64e2&"
import script from "./StockClosingPrintDetail_Company.vue?vue&type=script&lang=js&"
export * from "./StockClosingPrintDetail_Company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports